import CommodityRules from './CommodityRules';

export default (props) => {
  return <CommodityRules {...props} />;
};
